<template>
  <div class="print-btn align-self-end">
    <a
      class="button yellow-button goprint no-print action__print"
      @click="onPrintClick"
      >{{ print }}</a
    >
  </div>
</template>

<script>
import Locale from '../../../services/locale'

export default {
  name: 'PrintAction',
  props: {
    localeService: Locale,
  },
  computed: {
    print() {
      return this.localeService.getConstantTranslationByKey('print')
    },
  },
  methods: {
    onPrintClick() {
      window.print()
    },
  },
}
</script>
